"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { getPageScrollElement } from "@/lib/scroll/pageScroll";

/** Reset the page scrollport on client navigations (window no longer scrolls). */
export default function PageScrollManager() {
  const pathname = usePathname();

  useEffect(() => {
    const el = getPageScrollElement();
    if (el) el.scrollTop = 0;
  }, [pathname]);

  return null;
}
